// components/user/bank-account/BankView.jsx
import React from "react";
import { useSelector } from "react-redux";
import { Card, Button, Empty } from "antd";
import {
  BankOutlined,
  CreditCardOutlined,
  QrcodeOutlined,
  EditOutlined,
  UserOutlined,
  BankFilled,
} from "@ant-design/icons";

const BankView = ({ onEdit, isDarkMode }) => {
  const { user } = useSelector((state) => state.profile);
  const bankDetails = user?.bank_details;

  const InfoItem = ({ icon, label, value }) => (
    <div className="flex items-start gap-3 py-2.5 border-b border-gray-100 last:border-0">
      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gray-50 dark:bg-gray-800">
        {icon}
      </div>
      <div className="flex-1">
        <div
          className={`text-xs ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
        >
          {label}
        </div>
        <div
          className={`text-sm font-medium ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
        >
          {value && value !== "null" && value !== "undefined"
            ? value
            : "Not provided"}
        </div>
      </div>
    </div>
  );

  const hasBankDetails =
    bankDetails && bankDetails.bank_name && bankDetails.bank_name !== "null";

  return (
    <div className="pt-2">
      <Card className="border-0 shadow-sm rounded-xl">
        <div className="flex items-center justify-between pb-3 mb-4 border-b border-gray-100 dark:border-gray-700">
          <h3
            className={`text-sm font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            Bank Information
          </h3>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={onEdit}
            size="small"
            className="bg-green-600 hover:bg-green-700"
          >
            {hasBankDetails ? "Edit Details" : "Add Details"}
          </Button>
        </div>

        {!hasBankDetails ? (
          <Empty
            description="No bank details added yet"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className="py-8"
          />
        ) : (
          <>
            <InfoItem
              icon={<UserOutlined className="text-sm text-green-500" />}
              label="Account Holder Name"
              value={bankDetails?.banking_name}
            />

            <InfoItem
              icon={<BankFilled className="text-sm text-blue-500" />}
              label="Bank Name"
              value={bankDetails?.bank_name}
            />

            <InfoItem
              icon={<CreditCardOutlined className="text-sm text-purple-500" />}
              label="Account Number"
              value={bankDetails?.account_no}
            />

            <InfoItem
              icon={<BankOutlined className="text-sm text-orange-500" />}
              label="IFSC Code"
              value={bankDetails?.ifsc_code}
            />

            <InfoItem
              icon={<BankOutlined className="text-sm text-red-500" />}
              label="Branch"
              value={bankDetails?.branch}
            />

            <InfoItem
              icon={<QrcodeOutlined className="text-sm text-indigo-500" />}
              label="UPI ID"
              value={bankDetails?.upi_id}
            />
          </>
        )}
      </Card>
    </div>
  );
};

export default BankView;
